export default {"src":"/_next/static/media/data-room-home-img.c9ad4a69.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};